module.exports = "pegasus/assets/theme4/twitter-icon-1.png";